export default "__VITE_ASSET__CS2B6p1P__"